import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { SearchRequest, SearchResponse } from '@usf/product-types';
import { Observable } from 'rxjs';
import { State } from 'src/app/store';
import {
  selectFilterRefinementMap,
  selectTotalFilter,
} from '../selectors/search-filter-selector';
import { ProductAnalyticsService } from '@usf/ngrx-product';
import { Params } from '@angular/router';
import { SearchFilterSelected } from '@search/shared/models/search-filter-selected';

@Injectable({
  providedIn: 'root',
})
export class SearchFilterService {
  constructor(
    protected store: Store<State>,
    private productAnalyticsService: ProductAnalyticsService,
  ) {}

  getTotalFilter(searchRequest: SearchRequest): Observable<number> {
    return this.store.select(selectTotalFilter(searchRequest));
  }

  getFilterRefinementMap(
    searchRequest: SearchRequest,
  ): Observable<{ [key: string]: number | string }> {
    return this.store.select(selectFilterRefinementMap(searchRequest));
  }

  trackAppliedSearchFilters(
    requestQueryParam: Params,
    searchResponse: SearchResponse,
    searchFilterSelected: SearchFilterSelected,
  ) {
    let filters = '';
    filters += this.buildFilterRangeRefinementToTrack(requestQueryParam);
    filters += this.buildFilterRefinementToTrack(searchResponse);
    filters += this.buildFCurrentFilterToTrack(searchFilterSelected);
    if (filters !== '') {
      this.productAnalyticsService.trackSearchFilterApply(filters);
    }
  }

  buildFilterRangeRefinementToTrack(requestQueryParam: Params): string {
    let filters = '';
    if (
      requestQueryParam?.rangeRefinements !== undefined &&
      requestQueryParam?.rangeRefinements.length > 0
    ) {
      const rangeSelectedFilter = requestQueryParam['rangeSelectedFilter'];
      let ranges: string[] = requestQueryParam?.rangeRefinements.split('||');
      let rangesNames = ranges.map(value => value.split('|')[0]).join();
      filters = `${rangeSelectedFilter}=${rangesNames};`;
    }
    return filters;
  }

  buildFilterRefinementToTrack(searchResponse: SearchResponse): string {
    let temp_filters = {};
    for (const selectedFilter of searchResponse?.breadCrumbs?.selectedFilters) {
      if (temp_filters.hasOwnProperty(selectedFilter.displayName)) {
        temp_filters[selectedFilter.displayName] =
          temp_filters[selectedFilter.displayName] + ',' + selectedFilter.label;
      } else {
        temp_filters[selectedFilter.displayName] = selectedFilter.label;
      }
    }

    const entriesFilter = Object.entries(temp_filters);
    const temp_str = entriesFilter.reduce(
      (acc, [key, value], index) =>
        `${acc}${key}=${value}${index + 1 === entriesFilter.length ? '' : ';'}`,
      '',
    );
    return temp_str;
  }

  buildFCurrentFilterToTrack(
    searchFilterSelected: SearchFilterSelected,
  ): string {
    if (
      searchFilterSelected?.filterNav?.displayName &&
      searchFilterSelected?.refinementItem?.name
    ) {
      return `${searchFilterSelected?.filterNav?.displayName}=${searchFilterSelected?.refinementItem?.name}`;
    }
    return '';
  }

  trackClickedSearchFilter(searchFilterSelected: SearchFilterSelected) {
    const searchFilterSelectedStr = this.buildFCurrentFilterToTrack(
      searchFilterSelected,
    );
    this.productAnalyticsService.trackClickedSearchFilter(
      searchFilterSelectedStr,
    );
  }
}
